package com.jingfangpai.common.orm.mapping.enums

import org.jooq.ICatalog
import org.jooq.ISchema
import org.jooq.IEnumType
import kotlinx.serialization.Serializable

@Serializable
enum class CommentType(private val literal: String) : IEnumType {
	注解("注解"),
	笔记("笔记"),
	评论("评论");
	override fun getCatalog(): ICatalog? {return null}
	override fun getSchema() :ISchema? {return null}
	override fun getName(): String? {return "comment_type"}
	override fun getLiteral(): String {return literal}
}
